<template>
  <Modal :open="open" @close="$emit('close')">
    <h1 class="text-center font-extrabold text-xl">Mise à jour du produit irréparable</h1>

    <Selector
      class="mt-3"
      id="status"
      name="status"
      label="Statut"
      :required="true"
      v-model="status"
      :options="statusOptions"
    />

    <FormField
      class="mt-3"
      id="trackingNumber"
      label="Numéro de suivi"
      name="trackingNumber"
      required
      v-model="trackingNumber"
    />

    <FormField
      class="mt-3"
      id="valuationAmount"
      label="Valorisation du produit"
      name="valuationAmount"
      trailing-add-ons="€"
      required
      v-model="valuationAmount"
    />

    <div class="mt-3 flex justify-center">
      <GenericButton class="items-center" @click="updateResource">Mettre à jour</GenericButton>
    </div>
  </Modal>
</template>

<script>
import { FormField, GenericButton, Modal, Selector } from "@estaly/ui";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { GenericButton, FormField, Selector, Modal },
  props: {
    open: {
      required: true,
      type: Boolean,
    },
    unfixeableClaimProduct: {
      required: true,
      type: Object,
    },
  },

  data: () => {
    return {
      status: null,
      trackingNumber: null,
      valuationAmount: null,
    };
  },

  mounted() {
    this.initiateData();
  },

  emits: ["close", "updated"],

  watch: {
    open(newValue) {
      if (newValue) {
        this.initiateData();
      }
    },
  },

  computed: {
    ...mapGetters("unfixeableClaimProducts", ["statuses"]),

    statusOptions() {
      return this.statuses().map((status) => ({
        value: status,
        label: this.$t(`unfixeable_claim_products.status.${status}`),
      }));
    },
  },

  methods: {
    ...mapActions("unfixeableClaimProducts", ["update"]),
    ...mapActions("notifications", ["notify"]),

    initiateData() {
      this.status = this.unfixeableClaimProduct?.status;
      this.trackingNumber = this.unfixeableClaimProduct?.trackingNumber;
      this.valuationAmount = this.unfixeableClaimProduct?.valuationAmount;
    },

    async updateResource() {
      const response = await this.update({
        id: this.unfixeableClaimProduct.id,
        data: {
          status: this.status,
          trackingNumber: this.trackingNumber,
          valuationAmount: this.valuationAmount,
        },
      });

      if (response?.success) {
        this.$emit("close");
        this.$emit("updated");
      }
    },
  },
};
</script>
